import { Component, OnInit } from '@angular/core';
import { Protocol } from '../modal/Protocol';
import { VictorServiceService } from '../apiService/victor-service.service';
import { Router } from '@angular/router';
  import {throwError} from 'rxjs';
import { Role } from '../modal/Role';
import { Project } from '../modal/project';
import { getDevice } from '../modal/getdevice';
import { getControllerById } from '../modal/controllerbyid';
import { ExcelService } from '../excel.service';
@Component({
  selector: 'app-data',
  templateUrl: './data.component.html',
  styleUrls: ['./data.component.css']
})
export class DataComponent implements OnInit {

  user: getControllerById;
  users: getControllerById[];
  loading = false;
  cpy=false;
  updateIndex;
  color;
  pageNumber=1;
  numberOfPage;
  alertMsg= 'Please enter valid page number! 0 To  ';
  allDevices: getDevice[];
  bRole;
  //companyIds =[1,2,3,4,5];
  updatedUser: getControllerById;
  cpn=false;
  devices: string[];
  projects: string[];
  projectList: Project[];
    constructor(private excelService:ExcelService,private usersrv: VictorServiceService, private router: Router) { 

      if(sessionStorage.getItem('userName')===null){
        console.log('sesson strorage', sessionStorage.getItem('userName'));
        this.router.navigate(['']);
      }
      this.user =new getControllerById();
      // this.user.getdevice = new getDevice();
      this.users = [];
      this.devices = [];
      this.projects =[];
      console.log(sessionStorage.getItem('updateId'))
      console.log('getfinally')
      if(sessionStorage.getItem('role')==='Caller' ||  sessionStorage.getItem('role')==='Closure'){
          this.bRole=true;
      }else{
        this.bRole=false;
      }
      this.usersrv.getcontrollerbyid(sessionStorage.getItem('updateId'),this.pageNumber).subscribe((data: getControllerById[])=>{
        this.users = data;
        console.log('Device Data',this.users);
     // this.updateIndex =this.users.indexOf({ "id": 1 });
     console.log(this.users.length)
     this.numberOfPage = Math.ceil(this.users.length/10);
     console.log('getting id',this.users[0].ID);
     sessionStorage.setItem('a',this.users[0].ID);
     sessionStorage.setItem('lat',this.users[0].Lat);
     console.log('Latitude Type',typeof(this.users[0].Lat))
     sessionStorage.setItem('long',this.users[0].Lon);
     for(let i =0;i<this.users.length;i++){
       console.log('for working',i)
       console.log('matching id detail',sessionStorage.getItem('updateId'))
       console.log('type of session',typeof(sessionStorage.getItem('updateId')))
       console.log('type of apiint',typeof(this.users[0].ID))
       var a = parseInt(sessionStorage.getItem('updateId'))
       console.log('type of a',typeof(a))
          if(this.users[i].ID===(sessionStorage.getItem('updateId'))){
            this.updateIndex = i;
            this.updatedUser = this.users[i];
            console.log('Details',this.updatedUser);
            console.log('Details',this.updatedUser.Bat_Volts);
            
            break;
          }
     }
      });
      
      
           this.usersrv.getUserProject(sessionStorage.getItem('userName')).subscribe((data:Project[])=>{
        this.projectList=data;
        console.log('user projects',this.projectList);
        for(let user of data){
          this.projects.push(user.projectName);
      }
      });
    
    }
   
    exportAsXLSX():void {
      this.excelService.exportAsExcelFile(this.users, 'sample');
    }
  
    ngOnInit() {

      if(sessionStorage.getItem('userName')===null){
        console.log('sesson strorage', sessionStorage.getItem('userName'));
        this.router.navigate(['']);
      }
    }

   
    getDatabyPageNumber(){
    
      console.log('page number');
      if(this.pageNumber>0){
        this.loading=true;
        this.usersrv.getcontrollerbyid(sessionStorage.getItem('updateId'),this.pageNumber).subscribe((data: getControllerById[])=>{
          this.users = data;
          console.log('Device Data',this.users);
       // this.updateIndex =this.users.indexOf({ "id": 1 });
       console.log(this.users.length)
       this.numberOfPage = Math.ceil(this.users.length/10);
       console.log('getting id',this.users[0].ID)
       for(let i =0;i<this.users.length;i++){
         console.log('for working',i)
         console.log('matching id detail',sessionStorage.getItem('updateId'))
         console.log('type of session',typeof(sessionStorage.getItem('updateId')))
         console.log('type of apiint',typeof(this.users[0].ID))
         var a = parseInt(sessionStorage.getItem('updateId'))
         console.log('type of a',typeof(a))
            if(this.users[i].ID===(sessionStorage.getItem('updateId'))){
              this.updateIndex = i;
              this.updatedUser = this.users[i];
              console.log('Details',this.updatedUser);
              console.log('Details',this.updatedUser.Bat_Volts);
              
              break;
            }
       }
        });
      }else{
        this.alertMsg = this.alertMsg + String(this.numberOfPage);
      alert(this.alertMsg);
      this.alertMsg = 'Please enter valid page number! 0 To  ';
      }
      
    }// end of getDatabyPagenumber


    location(){
      window.location.href='http://maps.google.com/maps?q='+ sessionStorage.getItem('lat')+','+sessionStorage.getItem('long');
      // window.location.href='http://maps.google.com/maps?q=28.6721544,77.4300244'+ sessionStorage.getItem('a');
    }



    
    selectedCompanyId(id:string){
      this.usersrv.getcontrollerbyid(sessionStorage.getItem('updateId'),id).subscribe((data: getControllerById[])=>{
        this.users = data;
        console.log('Device Data',this.users);
     // this.updateIndex =this.users.indexOf({ "id": 1 });
     console.log(this.users.length)
     console.log('getting id',this.users[0].ID)
     for(let i =0;i<this.users.length;i++){
       console.log('for working',i)
       console.log('matching id detail',sessionStorage.getItem('updateId'))
       console.log('type of session',typeof(sessionStorage.getItem('updateId')))
       console.log('type of apiint',typeof(this.users[0].ID))
       var a = parseInt(sessionStorage.getItem('updateId'))
       console.log('type of a',typeof(a))
          if(this.users[i].ID===(sessionStorage.getItem('updateId'))){
            this.updateIndex = i;
            this.updatedUser = this.users[i];
            console.log('Details',this.updatedUser);
            console.log('Details',this.updatedUser.Bat_Volts);
            
            break;
          }
     }
      });
    }
    gotoobjects(id:string,name:string){
      console.log('updateUser');
      sessionStorage.setItem('deviceid',id);
      sessionStorage.setItem('name',name);
      console.log('id',sessionStorage.getItem('ID'));
      this.router.navigate(['/userhome/deviceobject']);
   }}
